export enum RedirectTypes{
  Field,
  KTL,
  SGP,
  InternalUsage,
  SGI,
  LPG
}
